export default "__VITE_ASSET__1aff3845__"